import { render, staticRenderFns } from "./SlotSuggestions.vue?vue&type=template&id=1809c407&scoped=true&"
import script from "./SlotSuggestions.vue?vue&type=script&lang=js&"
export * from "./SlotSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./SlotSuggestions.vue?vue&type=style&index=0&id=1809c407&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1809c407",
  null
  
)

export default component.exports